import type { AsyncData } from '#app';
import type { IModelResponse } from '~/services/base/dto/base.dto';
import type { IModelLoginRequest, IModelLoginResponse } from './dto/jwt.dto';
import { ENUM } from '~/plugins/constants/enum';
import { DATA } from '~/plugins/constants/data';

export class JWTRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService;
  }

  async login(
    params: IModelLoginRequest
  ): Promise<AsyncData<IModelResponse<IModelLoginResponse>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/jwt/oauth/admin-console/login`,
      this.configService,
      {
        method: 'POST',
        body: params,
      }
    );
    if (dataResult.status.value === DATA.FETCH_STATUS.SUCCESS) {
      dataResult.data.value = Object.assign(dataResult.data.value, {
        data: dataResult.data.value,
        message: ENUM.API_RESPONSE_MESSAGE.SUCCESS,
      });
    }
    return dataResult;
  }

  async logout(): Promise<AsyncData<IModelResponse<null>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/jwt/oauth/admin-console/logout`,
      this.configService,
      {
        method: 'POST',
      }
    );
    return dataResult;
  }
}
